import { Typography } from 'antd'
import colors from 'helpers/colors'
import { useTranslation } from 'next-i18next'
import LockIcon from 'public/icons/lock.svg'
import { ReactElement } from 'react'

export const CustomerRankSection = ({
  customerRank,
}: {
  customerRank?: CustomerRank
}): ReactElement => {
  const { t } = useTranslation()

  if (!customerRank) return <></>
  if (customerRank.name === '公開') return <></>
  if (customerRank.name === '非公開')
    return (
      <div style={{ display: 'flex', gap: 8 }}>
        <Typography.Text
          style={{
            fontSize: '12px',
            lineHeight: 1,
            padding: '3px 8px',
            alignItems: 'center',
            display: 'flex',
            gap: '4px',
            textAlign: 'center',
            color: colors.white,
            background: 'black',
          }}
        >
          <LockIcon
            fill={colors.white}
            style={{ width: '16px', height: '16px' }}
          />
          {t('非公開')}
        </Typography.Text>
      </div>
    )

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <Typography.Text
        style={{
          fontSize: '12px',
          lineHeight: 1,
          padding: '3px 8px',
          alignItems: 'center',
          display: 'flex',
          gap: '4px',
          textAlign: 'center',
          color: colors.white,
          background: 'black',
        }}
      >
        <LockIcon
          fill={colors.white}
          style={{ width: '16px', height: '16px' }}
        />
        {t('限定公開')}
      </Typography.Text>
      <Typography.Text
        style={{
          fontSize: '12px',
          lineHeight: 1.5,
          padding: '2px 8px',
          textAlign: 'center',
          border: 'black 1px solid',
        }}
      >
        {customerRank.name}
      </Typography.Text>
    </div>
  )
}
